<!-- Loader Start -->
<div class="loader" *ngIf="isLoading">
    <div class="spinner">
        <img src="../assets/images/all-instructor/loader.gif" alt="loader" class="img-fluid">
    </div>
</div>
<!-- Loader End -->